import React, { FC, memo } from 'react';
import { Divider, Grid, Paper, Typography } from '@material-ui/core';
import { paymentSummary } from 'src/redux/slices/customer-payment';
import { formatCurrency } from 'src/utils';
import useCustomerPayment from 'src/hooks/customer-payment/use-customer-payment';
import { Options } from './Options';

interface Props {}

const Component: FC<Props> = () => {
  const { customerPaymentComputation } = useCustomerPayment();
  return (
    <Paper style={{ marginTop: 20 }}>
      <Grid container spacing={3}>
        {paymentSummary.map((summary) => (
          <Grid
            key={summary?.key}
            item
            xs={6}
            md={3}
            style={{ textAlign: 'center' }}
          >
            <Typography variant="h5">{summary?.col_name}</Typography>
            <Typography variant="h5" style={{ color: summary?.color }}>
              {summary.key === 'number_of_transactions'
                ? customerPaymentComputation?.computation[summary.key]
                : formatCurrency(
                    Number(
                      customerPaymentComputation?.computation[summary.key]
                    ) || 0
                  )}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Divider style={{ margin: '20px 30px' }} />
      <Options />
    </Paper>
  );
};

export const PaymentSummary = memo(Component);
